// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
  pointer-events: auto;
  opacity: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.box {
  max-width: 500px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: #fff;
  border-radius: 12px;
  margin: 0px auto;
  pointer-events: auto;
  opacity: 1;
  z-index: 1000;
  min-height: 200px;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.dialog-header,
.analytics-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Make divider span full dialog width by offsetting box padding (25px) */
  margin-left: -25px;
  margin-right: -25px;
  padding: 12px 16px; /* reduced padding */
  background: transparent;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}
.dialog-header h2,
.analytics-header h2 {
  margin: 0;
  font-size: 18px; /* slightly smaller */
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px; /* tighter gap */
  color: #333;
}
.dialog-header .header-icon,
.analytics-header .header-icon {
  font-size: 20px; /* smaller icon */
  width: 20px;
  height: 20px;
  color: #333;
  background: transparent; /* no bg */
  border: none; /* no border */
  box-shadow: none;
}

.close-button {
  color: #1a1a1a;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  min-width: 40px;
  height: 40px;
}
.close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.close-ico {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #212427;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
}

.close-ico .close-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  background: #fff;
  position: relative;
  padding: 20px 0;
  text-align: center;
}

.icon-container {
  margin-bottom: 20px;
}

.blocker-icon {
  font-size: 80px;
  width: 80px;
  height: 80px;
  color: #f44336;
  background: transparent; /* remove bg */
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.private-blocker .blocker-icon {
  color: #9c27b0;
  background: transparent;
}

.restricted-blocker .blocker-icon {
  color: #ff9800;
  background: transparent;
}

.loading-blocker .icon-container {
  margin-bottom: 20px;
}
.loading-blocker h2 {
  margin: 0 0 15px 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}
.loading-blocker p {
  margin: 0 0 30px 0;
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

h2 {
  margin: 0 0 15px 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

p {
  margin: 0 0 30px 0;
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.action-buttons {
  display: flex;
  gap: 12px;
  align-items: stretch;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
}

.action-btn {
  width: 100%;
  min-width: 0;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  transition: all 0.3s ease !important;
  background-color: #5ea1d8 !important;
  color: white !important;
  border: none !important;
}

.action-btn:hover {
  background-color: #4a8bc2 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);
}

.action-btn[color=accent] {
  background-color: #ff9800 !important;
}

.action-btn[color=accent]:hover {
  background-color: #f57c00 !important;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
}

.action-btn.secondary {
  background: transparent !important;
  color: #666 !important;
  border: 1px solid #e0e0e0 !important;
}

.action-btn.secondary:hover {
  background: #f5f5f5 !important;
  color: #333 !important;
}

.action-btn[disabled] {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.action-btn mat-spinner {
  margin-right: 8px;
}

@media (min-width: 1200px) {
  .container {
    max-width: 600px;
  }
  .box {
    max-width: 600px;
    padding: 0px 30px;
  }
  .analytics-header {
    padding: 16px 20px;
    margin-left: -30px;
    margin-right: -30px;
  }
  .analytics-header h2 {
    font-size: 20px;
  }
  .analytics-header .close-button {
    min-width: 44px;
    height: 44px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 22px;
    width: 22px;
    height: 22px;
  }
  .blocker-icon {
    font-size: 90px;
    width: 90px;
    height: 90px;
  }
  h2 {
    font-size: 26px;
  }
  p {
    font-size: 18px;
  }
  .action-btn {
    min-width: 220px;
    padding: 14px 28px !important;
    font-size: 15px !important;
    height: 52px;
    min-height: 52px;
  }
  .action-btn mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
}
@media (min-width: 1024px) and (max-width: 1199px) {
  .container {
    max-width: 550px;
  }
  .box {
    max-width: 550px;
    padding: 0px 28px;
  }
  .analytics-header {
    padding: 15px 18px;
    margin-left: -28px;
    margin-right: -28px;
  }
  .analytics-header h2 {
    font-size: 19px;
  }
  .analytics-header .close-button {
    min-width: 42px;
    height: 42px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 21px;
    width: 21px;
    height: 21px;
  }
  .blocker-icon {
    font-size: 85px;
    width: 85px;
    height: 85px;
  }
  h2 {
    font-size: 25px;
  }
  p {
    font-size: 17px;
  }
  .action-btn {
    min-width: 210px;
    padding: 13px 26px !important;
    font-size: 14px !important;
    height: 50px;
    min-height: 50px;
  }
  .action-btn mat-icon {
    font-size: 19px;
    width: 19px;
    height: 19px;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .container {
    max-height: 90vh;
    max-width: calc(100vw - 40px);
    margin: 20px auto;
  }
  .box {
    max-height: 90vh;
    max-width: calc(100vw - 40px);
    width: calc(100vw - 40px);
    margin: 0;
    padding: 0px 24px;
    border-radius: 10px;
    min-height: 200px;
  }
  .analytics-header {
    padding: 14px 20px;
    margin-left: -24px;
    margin-right: -24px;
  }
  .analytics-header h2 {
    font-size: 18px;
  }
  .analytics-header .close-button {
    min-width: 38px;
    height: 38px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 19px;
    width: 19px;
    height: 19px;
  }
  .des-box {
    padding: 22px 0;
  }
  .blocker-icon {
    font-size: 70px;
    width: 70px;
    height: 70px;
  }
  h2 {
    font-size: 22px;
    margin-bottom: 14px;
  }
  p {
    font-size: 15px;
    margin-bottom: 22px;
  }
  .action-buttons {
    gap: 14px;
    margin-top: 22px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
  }
  .action-btn {
    min-width: 190px;
    padding: 11px 22px !important;
    font-size: 14px !important;
    height: 50px;
    min-height: 50px;
    touch-action: manipulation;
  }
  .action-btn mat-icon {
    font-size: 19px;
    width: 19px;
    height: 19px;
  }
}
@media (min-width: 768px) and (max-width: 1023px) and (orientation: landscape) {
  .container {
    max-height: 95vh;
    max-width: calc(100vw - 60px);
    width: calc(100vw - 60px);
    margin: 10px auto;
  }
  .box {
    max-height: 95vh;
    max-width: calc(100vw - 60px);
    width: calc(100vw - 60px);
    margin: 0;
    padding: 0px 20px;
  }
  .analytics-header {
    padding: 12px 18px;
    margin-left: -20px;
    margin-right: -20px;
  }
  .analytics-header h2 {
    font-size: 17px;
  }
  .des-box {
    padding: 18px 0;
  }
  .blocker-icon {
    font-size: 60px;
    width: 60px;
    height: 60px;
  }
  h2 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
    margin-bottom: 18px;
    align-items: center;
  }
  .action-buttons {
    gap: 12px;
    margin-top: 18px;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
  }
  .action-btn {
    min-width: 180px;
    height: 46px;
    min-height: 46px;
    font-size: 13px !important;
    display: flex;
    align-items: flex-end;
  }
  .action-btn mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
}
@media (max-width: 768px) {
  .container {
    max-height: 95vh;
    max-width: calc(100vw - 32px);
    width: calc(100vw - 32px);
    margin: 16px auto;
  }
  .box {
    max-height: 95vh;
    max-width: calc(100vw - 32px);
    width: calc(100vw - 32px);
    margin: 0;
    padding: 0px 20px;
    border-radius: 8px;
    min-height: 180px;
  }
  .analytics-header {
    padding: 16px 20px;
    margin-left: -20px;
    margin-right: -20px;
  }
  .analytics-header h2 {
    font-size: 18px;
  }
  .analytics-header .close-button {
    min-width: 36px;
    height: 36px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .des-box {
    padding: 20px 0;
  }
  .blocker-icon {
    font-size: 60px;
    width: 60px;
    height: 60px;
  }
  h2 {
    font-size: 20px;
    margin-bottom: 12px;
  }
  p {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .action-buttons {
    gap: 12px;
    margin-top: 20px;
  }
  .action-btn {
    min-width: 180px;
    padding: 10px 20px !important;
    font-size: 13px !important;
    height: 48px;
    min-height: 48px;
    touch-action: manipulation;
  }
  .action-btn mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
}
@media (max-width: 480px) {
  .container {
    margin: 8px auto;
    max-width: calc(100vw - 16px);
    width: calc(100vw - 16px);
  }
  .box {
    margin: 0;
    max-width: calc(100vw - 16px);
    width: calc(100vw - 16px);
    padding: 0px 16px;
    border-radius: 6px;
    min-height: 160px;
  }
  .analytics-header {
    padding: 12px 16px;
    margin-left: -16px;
    margin-right: -16px;
  }
  .analytics-header h2 {
    font-size: 16px;
  }
  .analytics-header .close-button {
    min-width: 32px;
    height: 32px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
  .des-box {
    padding: 16px 0;
  }
  .blocker-icon {
    font-size: 48px;
    width: 48px;
    height: 48px;
  }
  h2 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  p {
    font-size: 12px;
    margin-bottom: 16px;
  }
  .action-buttons {
    gap: 8px;
    margin-top: 16px;
  }
  .action-btn {
    min-width: 160px;
    padding: 8px 16px !important;
    font-size: 12px !important;
    height: 44px;
    min-height: 44px;
    gap: 6px;
  }
  .action-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
}
@media (max-width: 768px) and (orientation: landscape) {
  .container {
    max-height: 100vh;
    max-width: calc(100vw - 24px);
    width: calc(100vw - 24px);
    margin: 12px auto;
  }
  .box {
    max-height: 100vh;
    max-width: calc(100vw - 24px);
    width: calc(100vw - 24px);
    margin: 0;
    padding: 0px 16px;
  }
  .analytics-header {
    padding: 12px 16px;
    margin-left: -16px;
    margin-right: -16px;
  }
  .analytics-header h2 {
    font-size: 16px;
  }
  .des-box {
    padding: 16px 0;
  }
  .blocker-icon {
    font-size: 48px;
    width: 48px;
    height: 48px;
  }
  h2 {
    font-size: 18px;
    margin-bottom: 8px;
  }
  p {
    font-size: 12px;
    margin-bottom: 12px;
  }
  .action-buttons {
    gap: 8px;
    margin-top: 12px;
  }
  .action-btn {
    height: 40px;
    min-height: 40px;
    font-size: 12px !important;
  }
  .action-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
}
@media (max-width: 360px) {
  .container {
    margin: 4px auto;
    max-width: calc(100vw - 8px);
    width: calc(100vw - 8px);
  }
  .box {
    margin: 0;
    max-width: calc(100vw - 8px);
    width: calc(100vw - 8px);
    padding: 0px 12px;
    border-radius: 4px;
    min-height: 140px;
  }
  .analytics-header {
    padding: 10px 12px;
    margin-left: -12px;
    margin-right: -12px;
  }
  .analytics-header h2 {
    font-size: 14px;
  }
  .analytics-header .close-button {
    min-width: 28px;
    height: 28px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
  .des-box {
    padding: 12px 0;
  }
  .blocker-icon {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
  h2 {
    font-size: 16px;
    margin-bottom: 8px;
  }
  p {
    font-size: 11px;
    margin-bottom: 12px;
  }
  .action-buttons {
    gap: 6px;
    margin-top: 12px;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
  }
  .action-btn {
    min-width: 140px;
    height: 40px;
    min-height: 40px;
    font-size: 11px !important;
    gap: 4px;
  }
  .action-btn mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
}
::ng-deep .custom-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
  pointer-events: auto !important;
}

::ng-deep .dialoguebox {
  pointer-events: auto !important;
  opacity: 1 !important;
}

::ng-deep .mat-mdc-dialog-container {
  pointer-events: auto !important;
  opacity: 1 !important;
  padding: 0 !important;
  margin: 0 !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

::ng-deep .mat-mdc-dialog-surface {
  pointer-events: auto !important;
  opacity: 1 !important;
  padding: 0 !important;
  margin: 0 !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  background: transparent !important;
  box-shadow: none !important;
}

::ng-deep .cdk-overlay-pane {
  max-width: 100vw !important;
  max-height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  margin: 0 !important;
}

::ng-deep .cdk-overlay-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
  pointer-events: auto !important;
}

@media (min-width: 600px) and (max-width: 767px) {
  .container {
    max-height: 92vh;
    max-width: calc(100vw - 36px);
    width: calc(100vw - 36px);
    margin: 18px auto;
  }
  .box {
    max-height: 92vh;
    max-width: calc(100vw - 36px);
    width: calc(100vw - 36px);
    margin: 0;
    padding: 0px 22px;
    border-radius: 9px;
    min-height: 190px;
  }
  .analytics-header {
    padding: 15px 19px;
    margin-left: -22px;
    margin-right: -22px;
  }
  .analytics-header h2 {
    font-size: 17px;
  }
  .analytics-header .close-button {
    min-width: 37px;
    height: 37px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .des-box {
    padding: 21px 0;
  }
  .blocker-icon {
    font-size: 65px;
    width: 65px;
    height: 65px;
  }
  h2 {
    font-size: 21px;
    margin-bottom: 13px;
  }
  p {
    font-size: 14px;
    margin-bottom: 21px;
  }
  .action-buttons {
    gap: 13px;
    margin-top: 21px;
    flex-direction: column;
    align-items: center;
  }
  .action-btn {
    min-width: 185px;
    padding: 10px 21px !important;
    font-size: 13px !important;
    height: 49px;
    min-height: 49px;
    touch-action: manipulation;
  }
  .action-btn mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
}
@media (min-width: 481px) and (max-width: 599px) {
  .container {
    max-height: 94vh;
    max-width: calc(100vw - 24px);
    width: calc(100vw - 24px);
    margin: 12px auto;
  }
  .box {
    max-height: 94vh;
    max-width: calc(100vw - 24px);
    width: calc(100vw - 24px);
    margin: 0;
    padding: 0px 18px;
    border-radius: 7px;
    min-height: 170px;
  }
  .analytics-header {
    padding: 13px 17px;
    margin-left: -18px;
    margin-right: -18px;
  }
  .analytics-header h2 {
    font-size: 16px;
  }
  .analytics-header .close-button {
    min-width: 34px;
    height: 34px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 17px;
    width: 17px;
    height: 17px;
  }
  .des-box {
    padding: 18px 0;
  }
  .blocker-icon {
    font-size: 55px;
    width: 55px;
    height: 55px;
  }
  h2 {
    font-size: 19px;
    margin-bottom: 11px;
  }
  p {
    font-size: 13px;
    margin-bottom: 18px;
  }
  .action-buttons {
    gap: 11px;
    margin-top: 18px;
    flex-direction: column;
    align-items: center;
  }
  .action-btn {
    min-width: 170px;
    padding: 9px 18px !important;
    font-size: 12px !important;
    height: 46px;
    min-height: 46px;
    touch-action: manipulation;
  }
  .action-btn mat-icon {
    font-size: 17px;
    width: 17px;
    height: 17px;
  }
}
@media (max-width: 768px) {
  ::ng-deep .mat-mdc-dialog-container {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  ::ng-deep .mat-mdc-dialog-surface {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  ::ng-deep .cdk-overlay-pane {
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  ::ng-deep .mat-mdc-dialog-container {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  ::ng-deep .mat-mdc-dialog-surface {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  ::ng-deep .cdk-overlay-pane {
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
}
.device-id-hint {
  margin-top: 12px;
  font-size: 0.85rem;
  opacity: 0.85;
  word-break: break-all;
}

.device-id-hint code {
  font-size: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/flow-access-blocker/flow-access-blocker.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;AACF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAEF;;AACA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yEAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,gCAAA;AAEF;AADE;;EACE,SAAA;EACA,eAAA,EAAA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA,EAAA,gBAAA;EACA,WAAA;AAIJ;AAFE;;EACE,eAAA,EAAA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA,EAAA,UAAA;EACA,YAAA,EAAA,cAAA;EACA,gBAAA;AAKJ;;AADA;EACE,cAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AAIF;AAGE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAKA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA,EAAA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,uBAAA;AAFF;;AAKA;EACE,cAAA;EACA,uBAAA;AAFF;;AAME;EACE,mBAAA;AAHJ;AAME;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAJJ;AAOE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AALJ;;AASA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AANF;;AASA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AANF;;AASA;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,uBAAA;EACA,uBAAA;AANF;;AASA;EACE,oCAAA;EACA,2BAAA;EACA,8CAAA;AANF;;AASA;EACE,oCAAA;AANF;;AASA;EACE,oCAAA;EACA,6CAAA;AANF;;AASA;EACE,kCAAA;EACA,sBAAA;EACA,oCAAA;AANF;;AASA;EACE,8BAAA;EACA,sBAAA;AANF;;AASA;EACE,uBAAA;EACA,8BAAA;AANF;;AASA;EACE,iBAAA;AANF;;AAUA;EACE;IACE,gBAAA;EAPF;EAUA;IACE,gBAAA;IACA,iBAAA;EARF;EAWA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EATF;EAWE;IACE,eAAA;EATJ;EAYE;IACE,eAAA;IACA,YAAA;EAVJ;EAYI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAVN;EAeA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAbF;EAgBA;IACE,eAAA;EAdF;EAiBA;IACE,eAAA;EAfF;EAkBA;IACE,gBAAA;IACA,6BAAA;IACA,0BAAA;IACA,YAAA;IACA,gBAAA;EAhBF;EAkBE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAhBJ;AACF;AAqBA;EACE;IACE,gBAAA;EAnBF;EAsBA;IACE,gBAAA;IACA,iBAAA;EApBF;EAuBA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EArBF;EAuBE;IACE,eAAA;EArBJ;EAwBE;IACE,eAAA;IACA,YAAA;EAtBJ;EAwBI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAtBN;EA2BA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzBF;EA4BA;IACE,eAAA;EA1BF;EA6BA;IACE,eAAA;EA3BF;EA8BA;IACE,gBAAA;IACA,6BAAA;IACA,0BAAA;IACA,YAAA;IACA,gBAAA;EA5BF;EA8BE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA5BJ;AACF;AAiCA;EACE;IACE,gBAAA;IACA,6BAAA;IACA,iBAAA;EA/BF;EAkCA;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,SAAA;IACA,iBAAA;IACA,mBAAA;IACA,iBAAA;EAhCF;EAmCA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EAjCF;EAmCE;IACE,eAAA;EAjCJ;EAoCE;IACE,eAAA;IACA,YAAA;EAlCJ;EAoCI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAlCN;EAuCA;IACE,eAAA;EArCF;EAwCA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAtCF;EAyCA;IACE,eAAA;IACA,mBAAA;EAvCF;EA0CA;IACE,eAAA;IACA,mBAAA;EAxCF;EA2CA;IACE,SAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,uBAAA;EAzCF;EA4CA;IACE,gBAAA;IACA,6BAAA;IACA,0BAAA;IACA,YAAA;IACA,gBAAA;IACA,0BAAA;EA1CF;EA4CE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA1CJ;AACF;AA+CA;EACE;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,iBAAA;EA7CF;EAgDA;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,SAAA;IACA,iBAAA;EA9CF;EAiDA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EA/CF;EAiDE;IACE,eAAA;EA/CJ;EAmDA;IACE,eAAA;EAjDF;EAoDA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAlDF;EAqDA;IACE,eAAA;IACA,mBAAA;EAnDF;EAsDA;IACE,eAAA;IACA,mBAAA;IACA,mBAAA;EApDF;EAuDA;IACE,SAAA;IACA,gBAAA;IACA,sBAAA;IACA,uBAAA;IACA,oBAAA;EArDF;EAwDA;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,0BAAA;IACA,aAAA;IACA,qBAAA;EAtDF;EAuDE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EArDJ;AACF;AA0DA;EACE;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,iBAAA;EAxDF;EA2DA;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,SAAA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;EAzDF;EA4DA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EA1DF;EA4DE;IACE,eAAA;EA1DJ;EA6DE;IACE,eAAA;IACA,YAAA;EA3DJ;EA6DI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA3DN;EAgEA;IACE,eAAA;EA9DF;EAiEA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA/DF;EAkEA;IACE,eAAA;IACA,mBAAA;EAhEF;EAmEA;IACE,eAAA;IACA,mBAAA;EAjEF;EAoEA;IACE,SAAA;IACA,gBAAA;EAlEF;EAqEA;IACE,gBAAA;IACA,6BAAA;IACA,0BAAA;IACA,YAAA;IACA,gBAAA;IACA,0BAAA;EAnEF;EAqEE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAnEJ;AACF;AAuEA;EACE;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;EArEF;EAwEA;IACE,SAAA;IACA,6BAAA;IACA,yBAAA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;EAtEF;EAyEA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EAvEF;EAyEE;IACE,eAAA;EAvEJ;EA0EE;IACE,eAAA;IACA,YAAA;EAxEJ;EA0EI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAxEN;EA6EA;IACE,eAAA;EA3EF;EA8EA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA5EF;EA+EA;IACE,eAAA;IACA,mBAAA;EA7EF;EAgFA;IACE,eAAA;IACA,mBAAA;EA9EF;EAiFA;IACE,QAAA;IACA,gBAAA;EA/EF;EAkFA;IACE,gBAAA;IACA,4BAAA;IACA,0BAAA;IACA,YAAA;IACA,gBAAA;IACA,QAAA;EAhFF;EAkFE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAhFJ;AACF;AAqFA;EACE;IACE,iBAAA;IACA,6BAAA;IACA,yBAAA;IACA,iBAAA;EAnFF;EAsFA;IACE,iBAAA;IACA,6BAAA;IACA,yBAAA;IACA,SAAA;IACA,iBAAA;EApFF;EAuFA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EArFF;EAuFE;IACE,eAAA;EArFJ;EAyFA;IACE,eAAA;EAvFF;EA0FA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAxFF;EA2FA;IACE,eAAA;IACA,kBAAA;EAzFF;EA4FA;IACE,eAAA;IACA,mBAAA;EA1FF;EA6FA;IACE,QAAA;IACA,gBAAA;EA3FF;EA8FA;IACE,YAAA;IACA,gBAAA;IACA,0BAAA;EA5FF;EA8FE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA5FJ;AACF;AAiGA;EACE;IACE,gBAAA;IACA,4BAAA;IACA,wBAAA;EA/FF;EAkGA;IACE,SAAA;IACA,4BAAA;IACA,wBAAA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;EAhGF;EAmGA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EAjGF;EAmGE;IACE,eAAA;EAjGJ;EAoGE;IACE,eAAA;IACA,YAAA;EAlGJ;EAoGI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAlGN;EAuGA;IACE,eAAA;EArGF;EAwGA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAtGF;EAyGA;IACE,eAAA;IACA,kBAAA;EAvGF;EA0GA;IACE,eAAA;IACA,mBAAA;EAxGF;EA2GA;IACE,QAAA;IACA,gBAAA;IACA,aAAA;IACA,uBAAA;IACA,oBAAA;IACA,sBAAA;EAzGF;EA4GA;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,0BAAA;IACA,QAAA;EA1GF;EA4GE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA1GJ;AACF;AA+GA;EACE,+CAAA;EACA,+BAAA;AA7GF;;AAgHA;EACE,+BAAA;EACA,qBAAA;AA7GF;;AAgHA;EACE,+BAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AA7GF;;AAgHA;EACE,+BAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,2BAAA;AA7GF;;AAgHA;EACE,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,qBAAA;EACA,oBAAA;AA7GF;;AAgHA;EACE,+CAAA;EACA,+BAAA;AA7GF;;AAmHA;EACE;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,iBAAA;EAhHF;EAmHA;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,SAAA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;EAjHF;EAoHA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EAlHF;EAoHE;IACE,eAAA;EAlHJ;EAqHE;IACE,eAAA;IACA,YAAA;EAnHJ;EAqHI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAnHN;EAwHA;IACE,eAAA;EAtHF;EAyHA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAvHF;EA0HA;IACE,eAAA;IACA,mBAAA;EAxHF;EA2HA;IACE,eAAA;IACA,mBAAA;EAzHF;EA4HA;IACE,SAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;EA1HF;EA6HA;IACE,gBAAA;IACA,6BAAA;IACA,0BAAA;IACA,YAAA;IACA,gBAAA;IACA,0BAAA;EA3HF;EA6HE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA3HJ;AACF;AAgIA;EACE;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,iBAAA;EA9HF;EAiIA;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,SAAA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;EA/HF;EAkIA;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EAhIF;EAkIE;IACE,eAAA;EAhIJ;EAmIE;IACE,eAAA;IACA,YAAA;EAjIJ;EAmII;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAjIN;EAsIA;IACE,eAAA;EApIF;EAuIA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EArIF;EAwIA;IACE,eAAA;IACA,mBAAA;EAtIF;EAyIA;IACE,eAAA;IACA,mBAAA;EAvIF;EA0IA;IACE,SAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;EAxIF;EA2IA;IACE,gBAAA;IACA,4BAAA;IACA,0BAAA;IACA,YAAA;IACA,gBAAA;IACA,0BAAA;EAzIF;EA2IE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzIJ;AACF;AA8IA;EACE;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;EA5IF;EA+IA;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;EA7IF;EAgJA;IACE,2BAAA;IACA,4BAAA;EA9IF;AACF;AAkJA;EACE;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;EAhJF;EAmJA;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;EAjJF;EAoJA;IACE,2BAAA;IACA,4BAAA;EAlJF;AACF;AAqJA;EAAkB,gBAAA;EAAkB,kBAAA;EAAoB,aAAA;EAAe,qBAAA;AA/IvE;;AA+IgG;EAAuB,iBAAA;AA3IvH","sourcesContent":[".container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n  pointer-events: auto; // Ensure the container is interactive\n  opacity: 1; // Ensure it's not transparent/disabled\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.box {\n  max-width: 500px;\n  width: 100% !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  background: #fff;\n  border-radius: 12px;\n  margin: 0px auto;\n  pointer-events: auto; // Ensure the box is interactive\n  opacity: 1; // Ensure it's not transparent/disabled\n  z-index: 1000; // Ensure it's above other elements\n  min-height: 200px;\n}\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dialog-header,\n.analytics-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* Make divider span full dialog width by offsetting box padding (25px) */\n  margin-left: -25px;\n  margin-right: -25px;\n  padding: 12px 16px; /* reduced padding */\n  background: transparent;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  h2 {\n    margin: 0;\n    font-size: 18px; /* slightly smaller */\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 6px; /* tighter gap */\n    color: #333;\n  }\n  .header-icon {\n    font-size: 20px; /* smaller icon */\n    width: 20px;\n    height: 20px;\n    color: #333;\n    background: transparent; /* no bg */\n    border: none; /* no border */\n    box-shadow: none;\n  }\n}\n\n.close-button {\n  color: #1a1a1a;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  min-width: 40px;\n  height: 40px;\n\n  // &:hover {\n  //   background: rgba(0, 0, 0, 0.1);\n  //   transform: scale(1.1);\n  // }\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.close-ico {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #212427;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n}\n\n.close-ico .close-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  background: #fff;\n  position: relative;\n  padding: 20px 0;\n  text-align: center;\n}\n\n.icon-container {\n  margin-bottom: 20px;\n}\n\n.blocker-icon {\n  font-size: 80px;\n  width: 80px;\n  height: 80px;\n  color: #f44336;\n  background: transparent; /* remove bg */\n  border-radius: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.private-blocker .blocker-icon {\n  color: #9c27b0;\n  background: transparent;\n}\n\n.restricted-blocker .blocker-icon {\n  color: #ff9800;\n  background: transparent;\n}\n\n.loading-blocker {\n  .icon-container {\n    margin-bottom: 20px;\n  }\n\n  h2 {\n    margin: 0 0 15px 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n  }\n\n  p {\n    margin: 0 0 30px 0;\n    font-size: 16px;\n    color: #666;\n    line-height: 1.5;\n    max-width: 400px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\nh2 {\n  margin: 0 0 15px 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #333;\n}\n\np {\n  margin: 0 0 30px 0;\n  font-size: 16px;\n  color: #666;\n  line-height: 1.5;\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  align-items: stretch;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.action-btn {\n  width: 100%;\n  min-width: 0;\n  padding: 12px 24px !important;\n  border-radius: 8px !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  transition: all 0.3s ease !important;\n  background-color: #5ea1d8 !important;\n  color: white !important;\n  border: none !important;\n}\n\n.action-btn:hover {\n  background-color: #4a8bc2 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);\n}\n\n.action-btn[color=\"accent\"] {\n  background-color: #ff9800 !important;\n}\n\n.action-btn[color=\"accent\"]:hover {\n  background-color: #f57c00 !important;\n  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);\n}\n\n.action-btn.secondary {\n  background: transparent !important;\n  color: #666 !important;\n  border: 1px solid #e0e0e0 !important;\n}\n\n.action-btn.secondary:hover {\n  background: #f5f5f5 !important;\n  color: #333 !important;\n}\n\n.action-btn[disabled] {\n  opacity: 0.6 !important;\n  cursor: not-allowed !important;\n}\n\n.action-btn mat-spinner {\n  margin-right: 8px;\n}\n\n// Large Desktop and Ultra-wide screens (1200px+)\n@media (min-width: 1200px) {\n  .container {\n    max-width: 600px;\n  }\n\n  .box {\n    max-width: 600px;\n    padding: 0px 30px;\n  }\n\n  .analytics-header {\n    padding: 16px 20px;\n    margin-left: -30px;\n    margin-right: -30px;\n\n    h2 {\n      font-size: 20px;\n    }\n\n    .close-button {\n      min-width: 44px;\n      height: 44px;\n\n      mat-icon {\n        font-size: 22px;\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n\n  .blocker-icon {\n    font-size: 90px;\n    width: 90px;\n    height: 90px;\n  }\n\n  h2 {\n    font-size: 26px;\n  }\n\n  p {\n    font-size: 18px;\n  }\n\n  .action-btn {\n    min-width: 220px;\n    padding: 14px 28px !important;\n    font-size: 15px !important;\n    height: 52px;\n    min-height: 52px;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n// Large Tablets and Small Laptops (1024px - 1199px)\n@media (min-width: 1024px) and (max-width: 1199px) {\n  .container {\n    max-width: 550px;\n  }\n\n  .box {\n    max-width: 550px;\n    padding: 0px 28px;\n  }\n\n  .analytics-header {\n    padding: 15px 18px;\n    margin-left: -28px;\n    margin-right: -28px;\n\n    h2 {\n      font-size: 19px;\n    }\n\n    .close-button {\n      min-width: 42px;\n      height: 42px;\n\n      mat-icon {\n        font-size: 21px;\n        width: 21px;\n        height: 21px;\n      }\n    }\n  }\n\n  .blocker-icon {\n    font-size: 85px;\n    width: 85px;\n    height: 85px;\n  }\n\n  h2 {\n    font-size: 25px;\n  }\n\n  p {\n    font-size: 17px;\n  }\n\n  .action-btn {\n    min-width: 210px;\n    padding: 13px 26px !important;\n    font-size: 14px !important;\n    height: 50px;\n    min-height: 50px;\n\n    mat-icon {\n      font-size: 19px;\n      width: 19px;\n      height: 19px;\n    }\n  }\n}\n\n// Tablets (768px - 1023px)\n@media (min-width: 768px) and (max-width: 1023px) {\n  .container {\n    max-height: 90vh;\n    max-width: calc(100vw - 40px);\n    margin: 20px auto;\n  }\n\n  .box {\n    max-height: 90vh;\n    max-width: calc(100vw - 40px);\n    width: calc(100vw - 40px);\n    margin: 0;\n    padding: 0px 24px;\n    border-radius: 10px;\n    min-height: 200px;\n  }\n\n  .analytics-header {\n    padding: 14px 20px;\n    margin-left: -24px;\n    margin-right: -24px;\n\n    h2 {\n      font-size: 18px;\n    }\n\n    .close-button {\n      min-width: 38px;\n      height: 38px;\n\n      mat-icon {\n        font-size: 19px;\n        width: 19px;\n        height: 19px;\n      }\n    }\n  }\n\n  .des-box {\n    padding: 22px 0;\n  }\n\n  .blocker-icon {\n    font-size: 70px;\n    width: 70px;\n    height: 70px;\n  }\n\n  h2 {\n    font-size: 22px;\n    margin-bottom: 14px;\n  }\n\n  p {\n    font-size: 15px;\n    margin-bottom: 22px;\n  }\n\n  .action-buttons {\n    gap: 14px;\n    margin-top: 22px;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: center;\n  }\n\n  .action-btn {\n    min-width: 190px;\n    padding: 11px 22px !important;\n    font-size: 14px !important;\n    height: 50px;\n    min-height: 50px;\n    touch-action: manipulation;\n\n    mat-icon {\n      font-size: 19px;\n      width: 19px;\n      height: 19px;\n    }\n  }\n}\n\n// Tablet Landscape (768px - 1023px) and (orientation: landscape)\n@media (min-width: 768px) and (max-width: 1023px) and (orientation: landscape) {\n  .container {\n    max-height: 95vh;\n    max-width: calc(100vw - 60px);\n    width: calc(100vw - 60px);\n    margin: 10px auto;\n  }\n\n  .box {\n    max-height: 95vh;\n    max-width: calc(100vw - 60px);\n    width: calc(100vw - 60px);\n    margin: 0;\n    padding: 0px 20px;\n  }\n\n  .analytics-header {\n    padding: 12px 18px;\n    margin-left: -20px;\n    margin-right: -20px;\n\n    h2 {\n      font-size: 17px;\n    }\n  }\n\n  .des-box {\n    padding: 18px 0;\n  }\n\n  .blocker-icon {\n    font-size: 60px;\n    width: 60px;\n    height: 60px;\n  }\n\n  h2 {\n    font-size: 20px;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 14px;\n    margin-bottom: 18px;\n    align-items: center;\n  }\n\n  .action-buttons {\n    gap: 12px;\n    margin-top: 18px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: stretch;\n  }\n\n  .action-btn {\n    min-width: 180px;\n    height: 46px;\n    min-height: 46px;\n    font-size: 13px !important;\n    display: flex;\n    align-items: flex-end;\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n// Mobile Responsiveness\n@media (max-width: 768px) {\n  .container {\n    max-height: 95vh;\n    max-width: calc(100vw - 32px);\n    width: calc(100vw - 32px);\n    margin: 16px auto;\n  }\n\n  .box {\n    max-height: 95vh;\n    max-width: calc(100vw - 32px);\n    width: calc(100vw - 32px);\n    margin: 0;\n    padding: 0px 20px;\n    border-radius: 8px;\n    min-height: 180px;\n  }\n\n  .analytics-header {\n    padding: 16px 20px;\n    margin-left: -20px;\n    margin-right: -20px;\n\n    h2 {\n      font-size: 18px;\n    }\n\n    .close-button {\n      min-width: 36px;\n      height: 36px;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  .des-box {\n    padding: 20px 0;\n  }\n\n  .blocker-icon {\n    font-size: 60px;\n    width: 60px;\n    height: 60px;\n  }\n\n  h2 {\n    font-size: 20px;\n    margin-bottom: 12px;\n  }\n\n  p {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n\n  .action-buttons {\n    gap: 12px;\n    margin-top: 20px;\n  }\n\n  .action-btn {\n    min-width: 180px;\n    padding: 10px 20px !important;\n    font-size: 13px !important;\n    height: 48px;\n    min-height: 48px;\n    touch-action: manipulation;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    margin: 8px auto;\n    max-width: calc(100vw - 16px);\n    width: calc(100vw - 16px);\n  }\n\n  .box {\n    margin: 0;\n    max-width: calc(100vw - 16px);\n    width: calc(100vw - 16px);\n    padding: 0px 16px;\n    border-radius: 6px;\n    min-height: 160px;\n  }\n\n  .analytics-header {\n    padding: 12px 16px;\n    margin-left: -16px;\n    margin-right: -16px;\n\n    h2 {\n      font-size: 16px;\n    }\n\n    .close-button {\n      min-width: 32px;\n      height: 32px;\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n\n  .des-box {\n    padding: 16px 0;\n  }\n\n  .blocker-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  h2 {\n    font-size: 18px;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 12px;\n    margin-bottom: 16px;\n  }\n\n  .action-buttons {\n    gap: 8px;\n    margin-top: 16px;\n  }\n\n  .action-btn {\n    min-width: 160px;\n    padding: 8px 16px !important;\n    font-size: 12px !important;\n    height: 44px;\n    min-height: 44px;\n    gap: 6px;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n\n// Landscape orientation support for mobile devices\n@media (max-width: 768px) and (orientation: landscape) {\n  .container {\n    max-height: 100vh;\n    max-width: calc(100vw - 24px);\n    width: calc(100vw - 24px);\n    margin: 12px auto;\n  }\n\n  .box {\n    max-height: 100vh;\n    max-width: calc(100vw - 24px);\n    width: calc(100vw - 24px);\n    margin: 0;\n    padding: 0px 16px;\n  }\n\n  .analytics-header {\n    padding: 12px 16px;\n    margin-left: -16px;\n    margin-right: -16px;\n\n    h2 {\n      font-size: 16px;\n    }\n  }\n\n  .des-box {\n    padding: 16px 0;\n  }\n\n  .blocker-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  h2 {\n    font-size: 18px;\n    margin-bottom: 8px;\n  }\n\n  p {\n    font-size: 12px;\n    margin-bottom: 12px;\n  }\n\n  .action-buttons {\n    gap: 8px;\n    margin-top: 12px;\n  }\n\n  .action-btn {\n    height: 40px;\n    min-height: 40px;\n    font-size: 12px !important;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n\n// Extra small devices (phones in portrait)\n@media (max-width: 360px) {\n  .container {\n    margin: 4px auto;\n    max-width: calc(100vw - 8px);\n    width: calc(100vw - 8px);\n  }\n\n  .box {\n    margin: 0;\n    max-width: calc(100vw - 8px);\n    width: calc(100vw - 8px);\n    padding: 0px 12px;\n    border-radius: 4px;\n    min-height: 140px;\n  }\n\n  .analytics-header {\n    padding: 10px 12px;\n    margin-left: -12px;\n    margin-right: -12px;\n\n    h2 {\n      font-size: 14px;\n    }\n\n    .close-button {\n      min-width: 28px;\n      height: 28px;\n\n      mat-icon {\n        font-size: 14px;\n        width: 14px;\n        height: 14px;\n      }\n    }\n  }\n\n  .des-box {\n    padding: 12px 0;\n  }\n\n  .blocker-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n  }\n\n  h2 {\n    font-size: 16px;\n    margin-bottom: 8px;\n  }\n\n  p {\n    font-size: 11px;\n    margin-bottom: 12px;\n  }\n\n  .action-buttons {\n    gap: 6px;\n    margin-top: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .action-btn {\n    min-width: 140px;\n    height: 40px;\n    min-height: 40px;\n    font-size: 11px !important;\n    gap: 4px;\n\n    mat-icon {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n    }\n  }\n}\n\n// Global styles to ensure dialog works properly\n::ng-deep .custom-backdrop {\n  background-color: rgba(0, 0, 0, 0.5) !important;\n  pointer-events: auto !important;\n}\n\n::ng-deep .dialoguebox {\n  pointer-events: auto !important;\n  opacity: 1 !important;\n}\n\n::ng-deep .mat-mdc-dialog-container {\n  pointer-events: auto !important;\n  opacity: 1 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n::ng-deep .mat-mdc-dialog-surface {\n  pointer-events: auto !important;\n  opacity: 1 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n::ng-deep .cdk-overlay-pane {\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n::ng-deep .cdk-overlay-backdrop {\n  background-color: rgba(0, 0, 0, 0.5) !important;\n  pointer-events: auto !important;\n}\n\n// Additional responsive breakpoints for better tablet support\n\n// Medium Tablets (600px - 767px)\n@media (min-width: 600px) and (max-width: 767px) {\n  .container {\n    max-height: 92vh;\n    max-width: calc(100vw - 36px);\n    width: calc(100vw - 36px);\n    margin: 18px auto;\n  }\n\n  .box {\n    max-height: 92vh;\n    max-width: calc(100vw - 36px);\n    width: calc(100vw - 36px);\n    margin: 0;\n    padding: 0px 22px;\n    border-radius: 9px;\n    min-height: 190px;\n  }\n\n  .analytics-header {\n    padding: 15px 19px;\n    margin-left: -22px;\n    margin-right: -22px;\n\n    h2 {\n      font-size: 17px;\n    }\n\n    .close-button {\n      min-width: 37px;\n      height: 37px;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  .des-box {\n    padding: 21px 0;\n  }\n\n  .blocker-icon {\n    font-size: 65px;\n    width: 65px;\n    height: 65px;\n  }\n\n  h2 {\n    font-size: 21px;\n    margin-bottom: 13px;\n  }\n\n  p {\n    font-size: 14px;\n    margin-bottom: 21px;\n  }\n\n  .action-buttons {\n    gap: 13px;\n    margin-top: 21px;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .action-btn {\n    min-width: 185px;\n    padding: 10px 21px !important;\n    font-size: 13px !important;\n    height: 49px;\n    min-height: 49px;\n    touch-action: manipulation;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n// Small Tablets and Large Phones (481px - 599px)\n@media (min-width: 481px) and (max-width: 599px) {\n  .container {\n    max-height: 94vh;\n    max-width: calc(100vw - 24px);\n    width: calc(100vw - 24px);\n    margin: 12px auto;\n  }\n\n  .box {\n    max-height: 94vh;\n    max-width: calc(100vw - 24px);\n    width: calc(100vw - 24px);\n    margin: 0;\n    padding: 0px 18px;\n    border-radius: 7px;\n    min-height: 170px;\n  }\n\n  .analytics-header {\n    padding: 13px 17px;\n    margin-left: -18px;\n    margin-right: -18px;\n\n    h2 {\n      font-size: 16px;\n    }\n\n    .close-button {\n      min-width: 34px;\n      height: 34px;\n\n      mat-icon {\n        font-size: 17px;\n        width: 17px;\n        height: 17px;\n      }\n    }\n  }\n\n  .des-box {\n    padding: 18px 0;\n  }\n\n  .blocker-icon {\n    font-size: 55px;\n    width: 55px;\n    height: 55px;\n  }\n\n  h2 {\n    font-size: 19px;\n    margin-bottom: 11px;\n  }\n\n  p {\n    font-size: 13px;\n    margin-bottom: 18px;\n  }\n\n  .action-buttons {\n    gap: 11px;\n    margin-top: 18px;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .action-btn {\n    min-width: 170px;\n    padding: 9px 18px !important;\n    font-size: 12px !important;\n    height: 46px;\n    min-height: 46px;\n    touch-action: manipulation;\n\n    mat-icon {\n      font-size: 17px;\n      width: 17px;\n      height: 17px;\n    }\n  }\n}\n\n// Mobile-specific dialog improvements\n@media (max-width: 768px) {\n  ::ng-deep .mat-mdc-dialog-container {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n\n  ::ng-deep .mat-mdc-dialog-surface {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n\n  ::ng-deep .cdk-overlay-pane {\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n}\n\n// Tablet-specific dialog improvements\n@media (min-width: 768px) and (max-width: 1023px) {\n  ::ng-deep .mat-mdc-dialog-container {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n\n  ::ng-deep .mat-mdc-dialog-surface {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n\n  ::ng-deep .cdk-overlay-pane {\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n}\n\n.device-id-hint { margin-top: 12px; font-size: 0.85rem; opacity: 0.85; word-break: break-all; } .device-id-hint code { font-size: 0.8rem; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
